<template>
    <info-widget :collapsible="true" :is-expanded="expanded" v-if="managers" @toggle_expand="$emit('toggle_expand')">
        <template v-slot:title>Managers</template>

        <slot>

            <div class="p-2">
                <ul class="list-unstyled m-0">
                    <li v-if="employee && (payrollAdmins.length)">
                        <h4 class="theading mb-2">Organization</h4>

                        <ul class="list-unstyled m-0">
                            <li v-for="manager in payrollAdmins" :key="manager.id">
                                <div class="pb-2">
                                    <h6 class="text-semibold mb-qt">
                                        {{ manager.full_name }}
                                    </h6>
                                    <div class="text-muted">
                                        Payroll Administrator
                                    </div>
                                    <div v-show="manager.phone">
                                        <i class="fas fa-fw fa-phone text-muted mr-3q"></i>
                                        <a :href="'tel:' + manager.phone">{{ manager.phone_formatted }}</a>
                                    </div>
                                    <div>
                                        <i class="fas fa-fw fa-envelope text-muted mr-3q"></i>
                                        <a :href="'mailto:' + manager.email">{{ manager.email }}</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>

                    <template v-for="location in workLocations" :key="location.id">
                    <li class="border-top pt-2" v-if="managersByLocation[location.id][$store.state.security_roles.ROLE_LOCATION_MANAGER].length + managersByLocation[location.id][$store.state.security_roles.ROLE_LOCATION_MANAGER_APPROVER].length + managersByLocation[location.id][$store.state.security_roles.ROLE_STORE_MANAGER].length + managersByLocation[location.id][$store.state.security_roles.ROLE_EMPLOYEE_MANAGER].length">
                        <h4 class="theading mb-2">{{ location.name }}</h4>
                        <ul class="list-unstyled m-0">
                            <li v-for="manager in managersByLocation[location.id][$store.state.security_roles.ROLE_LOCATION_MANAGER].concat(managersByLocation[location.id][$store.state.security_roles.ROLE_LOCATION_MANAGER_APPROVER])" :key="manager.id">
                                <div class="pb-2">
                                    <h6 class="text-semibold mb-qt">
                                        {{ manager.full_name }}
                                    </h6>
                                    <div class="text-muted">
                                        Location Manager
                                    </div>
                                    <div v-show="manager.phone">
                                        <i class="fas fa-fw fa-phone text-muted mr-3q"></i>
                                        <a :href="'tel:' + manager.phone">{{ manager.phone_formatted }}</a>
                                    </div>
                                    <div>
                                        <i class="fas fa-fw fa-envelope text-muted mr-3q"></i>
                                        <a :href="'mailto:' + manager.email">{{ manager.email }}</a>
                                    </div>
                                </div>
                            </li>

                            <li v-for="manager in managersByLocation[location.id][$store.state.security_roles.ROLE_STORE_MANAGER]" :key="manager.id">
                                <div class="pb-2">
                                    <h6 class="text-semibold mb-qt">
                                        {{ manager.full_name }}
                                    </h6>
                                    <div class="text-muted">
                                        Department Manager
                                    </div>
                                    <div v-show="manager.phone">
                                        <i class="fas fa-fw fa-phone text-muted mr-3q"></i>
                                        <a :href="'tel:' + manager.phone">{{ manager.phone_formatted }}</a>
                                    </div>
                                    <div>
                                        <i class="fas fa-fw fa-envelope text-muted mr-3q"></i>
                                        <a :href="'mailto:' + manager.email">{{ manager.email }}</a>
                                    </div>
                                </div>
                            </li>

                            <li v-for="manager in managersByLocation[location.id][$store.state.security_roles.ROLE_EMPLOYEE_MANAGER]" :key="manager.id">
                                <div class="pb-2">
                                    <h6 class="text-semibold mb-qt">
                                        {{ manager.full_name }}
                                    </h6>
                                    <div class="text-muted">
                                        Employee Assistant
                                    </div>
                                    <div v-show="manager.phone">
                                        <i class="fas fa-fw fa-phone text-muted mr-3q"></i>
                                        <a :href="'tel:' + manager.phone">{{ manager.phone_formatted }}</a>
                                    </div>
                                    <div>
                                        <i class="fas fa-fw fa-envelope text-muted mr-3q"></i>
                                        <a :href="'mailto:' + manager.email">{{ manager.email }}</a>
                                    </div>
                                </div>
                            </li>

                        </ul>
                    </li>
                    </template>
                </ul>
            </div>
        </slot>
    </info-widget>
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import InfoWidget from '@/components/InfoWidget'

const sortManagers = (managers) => {
    managers.sort((a, b) => {
        if (a.full_name == b.full_name) {
            return a.id > b.id ? 1 : -1
        }
        return a.full_name > b.full_name ? 1 : -1
    })
}

const sortByNameAndId = (objects, nameField) => {
    objects.sort((a, b) => {
        if (a[nameField] == b[nameField]) {
            return a.id > b.id ? 1 : -1
        }
        return a[nameField] > b[nameField] ? 1 : -1
    })
}

export default {
    components: {ButtonRow, InfoWidget},
    props: ['employee', 'client', 'managers', 'expanded'],
    emits: ['toggle_expand'],
    computed: {
        payrollAdmins() {
            if (!this.employee) {return []}

            const pas = (this.managers[this.$store.state.security_roles.ROLE_PAYROLL_ADMIN] || [])
            const opas = (this.managers[this.$store.state.security_roles.ROLE_OFFICER_PA] || [])
            const managers = (pas.concat(opas)).map(csp => csp.security_profile)
            sortManagers(managers)
            return managers
        },

        workLocations() {
            if (!this.employee) {return []}
            if (!this.employee.jobs) {return []}

            const locations = {}
            this.employee.jobs.forEach(j => {
                locations[j.position.work_location.id] = j.position.work_location
            })
            const result = []
            Object.keys(locations).forEach(id => {
                result.push(locations[id])
            })
            sortByNameAndId(result, 'name')
            return result
        },
        managersByLocation() {
            const result = {}
            const roles = [
                this.$store.state.security_roles.ROLE_LOCATION_MANAGER,
                this.$store.state.security_roles.ROLE_LOCATION_MANAGER_APPROVER,
                this.$store.state.security_roles.ROLE_STORE_MANAGER,
                this.$store.state.security_roles.ROLE_EMPLOYEE_MANAGER,
            ]

            this.workLocations.forEach(w => {
                result[w.id] = {}
                roles.forEach(roleId => {
                    result[w.id][roleId] = []
                })
            })

            Object.keys(this.managers).forEach(role => {
                if (!roles.includes(role)) {return}

                this.managers[role].forEach(csp => {
                    let workLocationId;
                    if (this.$store.state.security_roles.LOCATION_LEVEL_ROLES.includes(csp.role)) {
                        csp.work_location_security_profiles.forEach(wlsp => {
                            workLocationId = wlsp.work_location.id
                            if (!result[workLocationId]) {return}

                            if (!result[workLocationId][csp.role].find(x => x.id == csp.security_profile.id)) {
                                result[workLocationId][csp.role].push(csp.security_profile)
                            }
                        })
                    }
                    else {
                        csp.security_profile_positions.forEach(spp => {
                            workLocationId = spp.position.work_location.id
                            if (!result[workLocationId]) {return}

                            if (!result[workLocationId][csp.role].find(x => x.id == csp.security_profile.id)) {
                                result[workLocationId][csp.role].push(csp.security_profile)
                            }
                        })

                    }

                })
            })

            return result
        },
    },
    data() {
        return {}
    },
    methods: {

    },
}
</script>
